import React from 'react';
import { theme } from 'antd';
import ReportingLayout from 'components/Layouts/ReportingLayout/ReportingLayout';
import CustomTable from 'components/Tables/CustomTable';
import { GAPS_EVIDENCES_COLUMNS } from 'constants/reports';
import { GAPS_EVIDENCES_DATA } from 'constants/gapsEvidencesData';
import * as Styled from './GapsEvidences.styled';

const { useToken } = theme;

const GapsEvidences: React.FC = () => {
  const { token } = useToken();

  return (
    <ReportingLayout>
      <>
        <Styled.ModalBackdrop />
        <Styled.ContentWrapper token={token}>
          <CustomTable
            drawTable={true}
            itemsCount={GAPS_EVIDENCES_DATA.length}
            columns={GAPS_EVIDENCES_COLUMNS}
            dataSource={GAPS_EVIDENCES_DATA}
            scroll={{ x: 1300, y: 400 }}
            loading={false}
            rowKey={(record: any) => record.key}
            sticky
          />
        </Styled.ContentWrapper>
      </>
    </ReportingLayout>
  );
};

export default GapsEvidences;
